import AnswerResult from './answerResult';
export default AnswerResult;
